import { combineReducers } from "redux";
import { policyOpening } from "./policyOpening";

const appReducer = combineReducers({
  policyOpening,
});

export const allReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return appReducer(state, action);
};
